module.exports = __webpack_public_path__ + "static/media/view4.4586a8d2.jpeg";